module.exports = "/assets/381f339c1d633c32fe9fac0439371107.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WM.png
// module id = 1965
// module chunks = 0